import { RootState } from '@/redux/store'
import { getFullProductDetails } from '@/utils/product'

export const selectStoreOrder = (state: RootState) => state['@order'].storeOrder

export const selectAvailableTimeSlots = (state: RootState) =>
  state['@order'].availableTimeSlots

export const selectEligiblePromotions = (state: RootState) =>
  state['@order'].eligiblePromotions

export const selectFullOrderItems = (state: RootState) => {
  const orderItems = state['@order'].storeOrder.data?.orderItems
  const menu = state['@menu'].data
  return orderItems
    ?.filter((item) => !item.isPromotionalItem && item.quantity > 0)
    ?.map((item) => getFullProductDetails(menu || [], item))
}

export const selectPromotionalOrderItems = (state: RootState) => {
  const orderItems = state['@order'].storeOrder.data?.orderItems
  const menu = state['@menu'].data
  return orderItems
    .filter((item) => item.isPromotionalItem)
    ?.map((item) => getFullProductDetails(menu || [], item))
}

export const selectSelectedPromotions = (state: RootState) =>
  state['@order'].selectedPromotions

export const selectUpdatingQuantity = (state: RootState) =>
  state['@order'].updatingQuantity
